import { Validators } from "@angular/forms"
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants"

export const investment_form_template = {
    amount: '0'
}

export const investment_form_validators = {
    amount: [Validators.required, Validators.pattern(/^\d+(\,\d+)?$/)]
}

export const INVESTMENT_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'attributeDescription',
        label: 'Nome fondo'
    },
    {
        key: 'amount',
        label: 'Importo da investire'
    }
]